import { render, staticRenderFns } from "./solicitacao-link.vue?vue&type=template&id=1d717008"
import script from "./solicitacao-link.vue?vue&type=script&lang=js"
export * from "./solicitacao-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports